import script from "./CaseManagementCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CaseManagementCoachingDigitalSignatureForm.vue?vue&type=script&setup=true&lang=js"

import "./CaseManagementCoachingDigitalSignatureForm.vue?vue&type=style&index=0&id=0fc79487&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fc79487"]])

export default __exports__